import { useEffect, useState } from 'react'
import { Button, Card, Col, Form, Image, Row } from 'react-bootstrap'
import NavTitle from '../../../components/nav-title'
import {
  useNavigate,
  useOutletContext,
  useSearchParams,
} from 'react-router-dom'
import { Controller, useForm } from 'react-hook-form'
import { TbEdit } from 'react-icons/tb'
import {
  delNotiAPI,
  getCheckUrlLarkGAPI,
  getDetailAttendanceNotiAPI,
  putNotiUserDetailsAPI,
} from '../../../services/setting/attendance-noti'
import SocialGroupsForm from './component/socialGroup'
import ImgUser from '../../../images/user.png'
import LabelDetail from '../../../components/custom/LabelDetail'
import LabelCustom from '../../../components/custom/LabelCustom'
import UserSelectCustom from '../../../components/custom/userSelectCustom'
import AlertSuccess from '../../../alert/AlertSuccess'
import Error_false from '../../../components/error/error-false'
import useSearchUser from '../../../hooks/use-search-user'
import { BsX } from 'react-icons/bs'
import ModalAlert from '../../../components/modal-alert'
import { ReactComponent as IconWarning } from '../../../images/warning2.svg'
import { PAGE_SETTING_NOTI } from '../../../router/routes'
import { useToggleMenuStore } from '../../../store/layout'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import BtnBack2 from '../../../components/btn-back2'
import { Skeleton } from 'antd'
import CheckResponsiveDesktop from '../../../helper/fnCheckResponsiveDesktop'

export default function AddNotiCheckInPege() {
  const {
    control,
    setValue,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm({
    mode: 'onChange', // ⭐ สำคัญ
  })
  const { t } = useTranslation()
  const { isToggleMenu } = useToggleMenuStore()
  const { orgRole } = useOutletContext()
  const roleId = useSelector((state) => state.roleReducer.role)
  const orgName =
    orgRole?.find((o) => String(o.org_id) === String(roleId))?.org ?? ''
  const [openDelete, setOpenDelete] = useState(false)
  const [openUnsaved, setOpenUnsaved] = useState(false)
  const [searchParams] = useSearchParams()
  const idParams = searchParams.get('id')
  const id = parseInt(idParams, 10)
  const [attendanceId, setAttendanceId] = useState(id)
  const [details, setDetails] = useState([])
  const [isLoading, setIsLoading] = useState(true)
  const [isRead, setIsRead] = useState(true)
  const [searchUser, setSearchUser] = useState()
  const hasId = Boolean(attendanceId)
  const [selectedUser, setSelectedUser] = useState(null)
  const { data: optionUser } = useSearchUser(searchUser, roleId)
  const navigate = useNavigate()
  const [isDuplicateUser, setIsDuplicateUser] = useState(false)
  const [duplicateMsg, setDuplicateMsg] = useState('')
  const watchLicensePlate = watch('LicensePlateNo')
  const watchRemark = watch('Remark')
  // const isDesktop = CheckResponsiveDesktop()
  const width = window.innerWidth
  const isMobile = width < 768
  const isTablet = width >= 768 && width <= 1024
  const isDesktop = width > 1024
  const [originalData, setOriginalData] = useState({
    username: null,
    licensePlate: '',
    remark: '',
  })

  useEffect(() => {
    if (idParams && !attendanceId) {
      setAttendanceId(Number(idParams))
    }
  }, [idParams])

  useEffect(() => {
    if (attendanceId) {
      getDetailNoti({ attendanceId })
    }
  }, [attendanceId])

  const getDetailNoti = async (body) => {
    setIsLoading(true)
    const res = await getDetailAttendanceNotiAPI(body)
    setIsLoading(false)
    if (!res) return
    if (res.status) {
      setSelectedUser(res.result)
      setDetails(res.result)
      setValue('LicensePlateNo', res?.result?.licensePlate ?? '')
      setValue('Remark', res?.result?.remark ?? '')
      setOriginalData({
        username: res?.result?.username ?? null,
        licensePlate: res?.result?.licensePlate ?? '',
        remark: res?.result?.remark ?? '',
      })
    } else {
      setSelectedUser()
      setDetails([])
    }
    setIsLoading(false)
  }
  const isDataChanged = hasId
    ? details?.orgId !== selectedUser?.orgId ||
      details?.code !== selectedUser?.code ||
      details?.username !== selectedUser?.username ||
      (details?.licensePlate ?? '-') !==
        (control._formValues?.LicensePlateNo ?? '-') ||
      (details?.remark ?? '-') !== (control._formValues?.Remark ?? '-')
    : false

  const handleCancel = () => {
    // 👉 ถ้าไม่มีการเปลี่ยนแปลงอะไรเลย
    if (hasId && !isDataChanged) {
      setIsRead(true)
      return
    }

    // 👉 ถ้ามีการเปลี่ยนแปลง
    setIsRead(true)
    setSelectedUser(null)

    fnCancle()

    // ⭐ clear form fields เฉพาะตอน "ไม่มี id"
    if (!hasId) {
      setValue('LicensePlateNo', '')
      setValue('Remark', '')
    }
  }

  const fnCancle = () => {
    const body = {
      attendanceId: id,
    }
    getDetailNoti(body)
  }

  const onSubmitUpdate = async (data) => {
    const body = {
      ...(attendanceId && { attendanceId }),
      orgId: selectedUser?.orgId ?? '',
      username: selectedUser?.username ?? '',
      licensePlate: data?.LicensePlateNo ?? '',
      remark: data?.Remark ?? '',
    }

    const resp = await putNotiUserDetailsAPI(body)
    if (!resp) return

    if (!resp.status) {
      Error_false(resp)
      return
    }

    AlertSuccess()

    const result = resp.result

    // ✅ sync form กับค่าที่ backend ส่งกลับมา
    setValue('LicensePlateNo', result?.licensePlate ?? '')
    setValue('Remark', result?.remark ?? '')

    // ✅ update baseline ทุกกรณี (Add + Edit)
    setOriginalData({
      username: result?.username ?? selectedUser?.username ?? null,
      licensePlate: result?.licensePlate ?? '',
      remark: result?.remark ?? '',
    })

    // ✅ ถ้าเป็น Add → set id ใหม่
    if (!attendanceId && result?.attendanceId) {
      const newId = result.attendanceId
      setAttendanceId(newId)

      navigate(`/setting/noti/add?id=${newId}`, { replace: true })
    }

    setIsRead(true)
  }

  const handleRemove = async (id) => {
    try {
      const payload = {
        attendanceNotifyType: 'PERSON',
        id: id,
      }

      await delNotiAPI(payload)
      AlertSuccess('Delete successfully.')
      navigate(PAGE_SETTING_NOTI)

      // ถ้ามี list ก็ refresh / filter ออก
      // setData(prev => prev.filter(item => item.id !== id));
    } catch (error) {
      console.error('Delete failed:', error)
    }
  }

  useEffect(() => {
    if (hasId && details?.personId && optionUser?.length) {
      const found = optionUser.find((u) => u.personId === details.personId)

      if (found) {
        setSelectedUser({
          value: found.value,
          label: found.labelText,
        })
      }
    }
  }, [hasId, details, optionUser])

  const checkDuplicateUser = async (user) => {
    if (!user?.orgId || !user?.username) return

    // ⭐ ถ้าเป็น Edit mode และ username ยังเป็นตัวเดิม → ไม่ต้องเช็ค
    if (hasId && user.username === originalData.username) {
      setIsDuplicateUser(false)
      setDuplicateMsg('')
      return
    }

    try {
      const res = await getCheckUrlLarkGAPI({
        orgId: user.orgId,
        username: user.username,
        checkType: 'PERSON',
      })

      if (!res?.status) {
        setIsDuplicateUser(true)
        setDuplicateMsg(res?.msg || 'Invalid value')
        return
      }

      if (res?.result?.isDuplicate === true) {
        setIsDuplicateUser(true)
        setDuplicateMsg(t('hrms_notification_error_employee_detail'))
        return
      }
      // ✅ ผ่าน
      setIsDuplicateUser(false)
      setDuplicateMsg('')
    } catch (err) {
      setIsDuplicateUser(true)
      setDuplicateMsg('Cannot verify employee')
    }
  }
  const currentLicensePlate = watchLicensePlate ?? ''
  const currentRemark = watchRemark ?? ''

  const isUserChanged =
    originalData.username !== (selectedUser?.username ?? null)

  const isPlateChanged = originalData.licensePlate !== currentLicensePlate

  const isRemarkChanged = originalData.remark !== currentRemark
  const isEditMode = Boolean(attendanceId)

  const isFormChanged = isEditMode
    ? isUserChanged || isPlateChanged || isRemarkChanged
    : Boolean(selectedUser || currentLicensePlate || currentRemark)

  const showSave = (!hasId && !selectedUser) || (hasId && !isRead)
  const showEdit = hasId && isRead
  // const showClearBtn = !hasId && selectedUser
  const isDuplicatePlate = !!errors.LicensePlateNo
  const isDisableSave =
    !isFormChanged || // ⭐ ไม่มีการเปลี่ยนแปลง → disable
    isDuplicateUser ||
    !selectedUser ||
    (hasId && isRead) ||
    isDuplicatePlate

  const showClearBtn = (!hasId && selectedUser) || (hasId && showSave)
  // const isUsernameChanged =
  //   hasId && details?.username && selectedUser?.username
  //     ? details.username !== selectedUser?.username
  //     : false

  const goBack = () => {
    if (isFormChanged) {
      // if (isDataChanged) {
      // if (isUsernameChanged) {
      setOpenUnsaved(true)
    } else {
      navigate(-1)
    }
  }

  return (
    <>
      <Row>
        <NavTitle>
          <BtnBack2
            onClick={goBack}
            text={
              id
                ? `Edit ${orgName} Employee in Group`
                : `Add ${orgName} Employee in Group`
            }
          />
        </NavTitle>
      </Row>
      <Col
        xl={12}
        style={{
          display: 'flex',
          flexDirection: 'column',
          height: '100vh',
        }}
      >
        <Row className="p-3 pt-0 g-3">
          <Col xl={12} md={12}>
            <Card
              style={{
                borderRadius: '8px',
                border: '1px solid var(--color-on-base-border-default)',
                boxShadow:
                  '0 2px 4px -4px rgba(0, 0, 0, 0.06), 0 0 1px 0 rgba(0, 0, 0, 0.12)',
                display: 'flex',
                flex: 1, // ⭐ ดัน footer ลงล่าง
                flexDirection: 'column',
                overflowX: 'hidden',
              }}
            >
              <div
                className="custom-scroll"
                style={{
                  flex: 1,
                  paddingRight: 8,
                  overflowY: 'auto',
                  overflowX: 'hidden', // 👈 ปิดแนวนอน
                }}
              >
                <Row className="p-4 g-3">
                  <Col
                    xl={12}
                    md={12}
                    style={{
                      color: 'var(--color-on-base-content-high)',
                      fontWeight: 500,
                      fontSize: '18px',
                    }}
                    className="d-flex justify-content-between align-items-center mb-2"
                  >
                    <div className="d-flex align-items-center">
                      <span>
                        {t('cms_notification_employee_datail_header')}
                        <span className="text-danger ms-1">*</span>
                      </span>
                    </div>

                    <div
                      style={{ visibility: showEdit ? 'visible' : 'hidden' }}
                    >
                      <Button
                        size="sm"
                        type="button"
                        className="px-3 bt-primary"
                        onClick={() => setIsRead(false)}
                      >
                        <TbEdit style={{ width: '14px' }} className="me-2" />
                        {t('hrms_notification_btn_edit')}
                      </Button>
                    </div>
                  </Col>

                  <Col xl={6}>
                    <Row className="g-3">
                      {!selectedUser && (
                        <Col xl={12} md={12}>
                          <div
                            style={{
                              fontSize: '14px',
                              fontWeight: 500,
                              color: ' var(--color-on-base-content-high)',
                            }}
                          >
                            {' '}
                            {t('hrms_notification_title_search_field')}
                          </div>
                          <UserSelectCustom
                            options={optionUser}
                            value={selectedUser?.value}
                            placeholder={t('hrms_notification_search_employee')}
                            isClearable={false}
                            onChange={(value, option) => {
                              const userData = option.data
                              setSelectedUser(userData)
                              checkDuplicateUser(userData)
                            }}
                            onInputChange={setSearchUser}
                          />
                        </Col>
                      )}

                      <Col xl={12} md={12}>
                        <Card
                          style={{
                            position: 'relative', // ⭐ สำคัญ
                            borderRadius: '8px',
                            border: isDuplicateUser
                              ? '1px solid var(--color-functional-content-error)'
                              : '1px solid var(--color-on-base-border-default)',
                            boxShadow:
                              '0 2px 4px -4px rgba(0, 0, 0, 0.06), 0 0 1px 0 rgba(0, 0, 0, 0.12)',
                            height: !selectedUser ? '152px' : '',
                          }}
                        >
                          {/* ❌ Close button */}
                          {showClearBtn && selectedUser && (
                            <div
                              onClick={() => {
                                setIsDuplicateUser(false)
                                setSelectedUser(null)
                                if (!hasId) {
                                  setValue('LicensePlateNo', '')
                                  setValue('Remark', '')
                                }
                              }}
                              style={{
                                width: 24,
                                height: 24,
                                borderRadius: 6,
                                border:
                                  '1px solid var(--color-on-base-border-default)',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                cursor: 'pointer',
                                position: 'absolute',
                                top: 12,
                                right: 12,
                              }}
                            >
                              <BsX size={20} />
                            </div>
                          )}
                          <Row className="my-auto" style={{ padding: '24px' }}>
                            {hasId && isLoading ? (
                              <>
                                {/* Avatar Skeleton */}
                                <Col xl={3} md={3} sm={3}>
                                  <Skeleton.Avatar
                                    active
                                    size={100}
                                    shape="circle"
                                  />
                                </Col>

                                {/* Detail Skeleton */}
                                <Col xl={9} md={9} sm={9}>
                                  <div className="d-flex align-items-center flex-wrap">
                                    <Skeleton.Input
                                      active
                                      // size="small"
                                      style={{ width: '100%', height: 14 }}
                                    />
                                  </div>

                                  {['100%', '100%', '100%'].map((w, i) => (
                                    <div key={i} className="mt-2">
                                      <Skeleton.Input
                                        active
                                        // size="small"
                                        style={{
                                          width: w,
                                          height: 14,
                                        }}
                                      />
                                    </div>
                                  ))}
                                </Col>
                              </>
                            ) : selectedUser ? (
                              <>
                                <Col xl={3} md={3} sm={3}>
                                  <Image
                                    fluid
                                    className="rounded-circle"
                                    style={{
                                      maxWidth: 100,
                                      maxHeight: 100,
                                      objectFit: 'cover',
                                    }}
                                    src={selectedUser?.avatar || ImgUser}
                                    onError={(event) => {
                                      event.target.src = ImgUser
                                      event.onerror = null
                                    }}
                                  />
                                </Col>

                                <Col xl={9} md={9} sm={9}>
                                  <div className="d-flex">
                                    <LabelCustom>
                                      {selectedUser?.nameEn}{' '}
                                      {selectedUser?.surnameEn}
                                    </LabelCustom>

                                    {selectedUser?.nicknameEn?.trim() ? (
                                      <span className="ms-2">
                                        <LabelDetail>
                                          ({selectedUser.nicknameEn})
                                        </LabelDetail>
                                      </span>
                                    ) : null}

                                    {+selectedUser?.statusId === 0 && (
                                      <span className="ms-2">
                                        <div
                                          style={{
                                            background:
                                              'var(--color-functional-foreground-error-subtle)',
                                            height: '18px',
                                            fontSize: '12px',
                                            padding: '0px 10px',
                                            borderRadius: '6px',
                                            color:
                                              'var(--color-functional-content-error)',
                                          }}
                                        >
                                          Terminate
                                        </div>
                                      </span>
                                    )}
                                  </div>
                                  {/* 
                                  {selectedUser?.nameTh && (
                                    <LabelDetail>
                                      {selectedUser?.nameTh}{' '}
                                      {selectedUser?.surnameTh} (
                                      {selectedUser?.nicknameTh})
                                    </LabelDetail>
                                  )} */}

                                  <LabelDetail>
                                    {selectedUser?.code ?? '-'}
                                  </LabelDetail>

                                  {selectedUser?.org && (
                                    <LabelDetail>
                                      {t(
                                        'hrms_notification_organization_employee',
                                      )}
                                      : {selectedUser?.org ?? '-'}
                                    </LabelDetail>
                                  )}

                                  {selectedUser?.positionEn && (
                                    <LabelDetail>
                                      {t('hrms_notification_position_employee')}
                                      : {selectedUser?.positionEn ?? '-'}
                                    </LabelDetail>
                                  )}
                                </Col>
                              </>
                            ) : (
                              <Col
                                className="text-center"
                                style={{
                                  color: 'var(--color-on-base-content-low)',
                                  fontSize: '20px',
                                  fontWeight: 400,
                                }}
                              >
                                <div>
                                  {t('hrms_notification_place_holder_no_data')}
                                </div>
                                <div>
                                  {t(
                                    'hrms_notification__place_holder_search_and_select_an_employee',
                                  )}
                                </div>
                              </Col>
                            )}
                          </Row>
                        </Card>
                        {isDuplicateUser && (
                          <div
                            style={{
                              color: 'var(--color-functional-content-error)',
                              fontSize: '12px',
                              marginTop: '6px',
                            }}
                          >
                            {duplicateMsg}
                          </div>
                        )}
                      </Col>
                    </Row>
                  </Col>
                  <Col xl={6} className="d-flex flex-column">
                    <Col xl={12} md={12} className="mb-2">
                      <LabelCustom>
                        {' '}
                        {t('hrms_notification_license_plate_num')}
                      </LabelCustom>
                      <Controller
                        name="LicensePlateNo"
                        control={control}
                        rules={{
                          validate: (value) => {
                            if (!value) return true

                            const plates = value
                              .split(',')
                              .map((v) => v.trim().toUpperCase())
                              .filter(Boolean)

                            const unique = new Set(plates)

                            if (unique.size !== plates.length) {
                              return 'Do not enter duplicate license plates.'
                            }

                            return true
                          },
                        }}
                        render={({
                          field: { onChange, value = '' },
                          fieldState: { error },
                        }) => (
                          <>
                            <Form.Control
                              className="custom-input"
                              disabled={hasId && isRead}
                              value={value}
                              onChange={onChange}
                              placeholder={t(
                                'hrms_notification_place_holder_license_plate',
                              )}
                              isInvalid={!!error}
                            />
                            {error && (
                              <div className="invalid-feedback d-block">
                                {error.message}
                              </div>
                            )}
                          </>
                        )}
                      />
                      <div
                        style={{
                          color: ' var(--color-on-base-content-subtle)',
                          fontSize: ' 12px',
                          fontWeight: 400,
                        }}
                      >
                        {t(
                          'hrms_notification_place_holder_format_license_plate_num',
                        )}
                      </div>
                    </Col>

                    <Col xl={12} md={12} className="mb-2">
                      <LabelCustom>{t('hrms_notification_remark')}</LabelCustom>
                      <Controller
                        name="Remark"
                        control={control}
                        render={({ field: { onChange, value = '' } }) => (
                          <>
                            <Form.Control
                              className="custom-input"
                              disabled={hasId && isRead}
                              value={value}
                              onChange={onChange}
                              maxLength={150}
                              placeholder={t(
                                'hrms_notification_place_holder_note_for_an_information',
                              )}
                            />
                            <div
                              style={{
                                color: ' var(--color-on-base-content-subtle)',
                                fontSize: ' 12px',
                                fontWeight: 400,
                              }}
                            >
                              {value.length}/150
                            </div>
                          </>
                        )}
                      />
                    </Col>

                    {showClearBtn && (
                      <Col
                        xl={12}
                        md={12}
                        className="d-flex justify-content-end gap-2 mt-auto"
                      >
                        <Button
                          className="bt-cancel"
                          type="button"
                          style={{ width: '146px' }}
                          onClick={() => {
                            setIsDuplicateUser(false)
                            handleCancel()
                            // if (hasId) {
                            //   getDetailNoti({ attendanceId })
                            // } else {
                            //   handleCancel()
                            // }
                          }}
                        >
                          {hasId
                            ? t('cms_notification_btn_reset')
                            : t('hrms_notification_btn_clear')}
                        </Button>

                        <Button
                          style={{
                            width: '146px',
                            borderRadius: 12,
                            backgroundColor: isDisableSave
                              ? 'var(--comp-btn-color-background-disable)'
                              : '',
                            color: isDisableSave
                              ? 'var(--color-on-base-content-disable)'
                              : '',
                            whiteSpace: 'nowrap',
                          }}
                          disabled={isDisableSave}
                          onClick={() => {
                            handleSubmit(onSubmitUpdate)()
                          }}
                        >
                          {t('hrms_notification_btn_save')}
                        </Button>
                      </Col>
                    )}
                  </Col>

                  <Col xl={12} className="m-0">
                    <hr />
                  </Col>

                  <Col xl={12}>
                    <Row>
                      <SocialGroupsForm
                        hasId={hasId}
                        attendanceId={attendanceId}
                      />
                    </Row>
                  </Col>
                </Row>
              </div>
            </Card>
          </Col>
        </Row>
      </Col>
      {hasId && (
        <div
          style={{
            position: 'fixed',
            bottom: 0,
            left: isDesktop ? (isToggleMenu ? 240 : 77) : 0,
            width: isDesktop
              ? `calc(100% - ${isToggleMenu ? 240 : 77}px)`
              : '100%',
            zIndex: 1000,
            background: '#fff',
            borderTop: '1px solid var(--color-base-border-default)',
            boxShadow: '0px 0px 1px 0px #0000001F, 0px 4px 16px -4px #00000014',
            transition: 'left 0.3s ease-in-out, width 0.3s ease-in-out',
          }}
        >
          <div
            style={{
              padding: '12px 16px',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              gap: 12,
            }}
          >
            <Button
              style={{
                flex: isMobile ? 1 : 'unset',
                minWidth: isMobile ? 0 : '124px',
              }}
              className="bt-del"
              onClick={() => setOpenDelete(true)}
            >
              {t('hrms_notification_btn_delete')}
            </Button>

            <Button
              className="bt-cancel"
              style={{
                flex: isMobile ? 1 : 'unset',
                minWidth: isMobile ? 0 : '124px',
                borderRadius: 12,
              }}
              onClick={goBack}
            >
              {t('hrms_notification_btn_back')}
            </Button>
          </div>
        </div>
      )}

      <ModalAlert
        open={openDelete}
        icon={<IconWarning width={74} />}
        title={t('hrms_notification_modal_delete_information_header')}
        titleColor="var(--color-accent-content-red)"
        description={t('hrms_notification_modal_delete_information_description')}
        okText={t('hrms_notification_btn_yes')}
        cancelText={t('hrms_notification_btn_no')}
        okType="danger"
        okStyle={{
          background: 'var(--color-functional-foreground-error)',
          fontWeight: 500,
          color: 'var(--color-on-primary-content-high)',
        }}
        payload={attendanceId}
        onOk={() => {
          attendanceId && handleRemove(attendanceId)
          setOpenDelete(false)
        }}
        onCancel={() => {
          setOpenDelete(false)
        }}
      />
      <ModalAlert
        open={openUnsaved}
        icon={<IconWarning width={74} />}
        title="Unsaved Changes"
        description={
          <>
            You have unsaved changes.
            <br />
            Are you sure you want to leave without saving?
          </>
        }
        okText="Discard"
        cancelText="Cancel"
        okType="danger"
        okStyle={{
          background: 'var(--color-functional-foreground-error)',
          fontWeight: 500,
          color: 'var(--color-on-primary-content-high)',
        }}
        onOk={() => {
          setOpenUnsaved(false)
          navigate(-1)
        }}
        onCancel={() => {
          setOpenUnsaved(false)
        }}
      />
    </>
  )
}
